'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import Link from 'next/link';
import { styled } from '@classify/react-core-components/styles';
import type { Course, TableOfContent } from '@openclassrooms/sdk-web';
import Typography from '@classify/react-core-components/Typography';
import tocItemToUrl from '../../_utils/tocItemToUrl';
const TocItemContainer = styled('li', {
  shouldForwardProp: prop => prop !== 'isCurrentlyDisplayed'
})<{
  isCurrentlyDisplayed: boolean;
}>(({
  theme,
  isCurrentlyDisplayed
}) => ({
  listStyle: 'none',
  padding: theme.spacing(1.5, 1, 1.5, 1),
  display: 'flex',
  ...(isCurrentlyDisplayed && {
    background: theme.palette.layout.background.navigationAlternative
  })
}));
const IconContainer = styled('div')(({
  theme: {
    spacing
  }
}) => ({
  paddingRight: spacing(2)
}));
const TocItemHeading = styled('h4')({
  margin: 0,
  padding: 0,
  lineHeight: 'initial'
});
const TocItemLink = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isCurrentlyDisplayed'
})<{
  isCurrentlyDisplayed: boolean;
}>(({
  theme,
  isCurrentlyDisplayed
}) => ({
  textDecoration: 'none',
  color: theme.palette.text.onMain,
  fontWeight: isCurrentlyDisplayed ? theme.typography.fontWeightBold : 'normal',
  '&:hover': {
    color: theme.palette.brand.primary
  }
}));
export interface TocItemProps {
  isCurrentlyDisplayed: boolean;
  learningStatusIcon: ReactNode;
  part: TableOfContent;
  label: string;
  course: Course;
  shouldPrefetch?: boolean;
  onClick?: () => void;
}
const TocItemWrapper = t0 => {
  const $ = _c(26);
  const {
    isCurrentlyDisplayed,
    learningStatusIcon,
    part,
    label,
    course,
    shouldPrefetch: t1,
    onClick: t2
  } = t0;
  const shouldPrefetch = t1 === undefined ? true : t1;
  const onClick = t2 === undefined ? _temp : t2;
  const router = useRouter();
  const searchParams = useSearchParams();
  const {
    id,
    type,
    title,
    slug
  } = part;
  let t3;
  if ($[0] !== course || $[1] !== id || $[2] !== searchParams || $[3] !== slug || $[4] !== title || $[5] !== type) {
    t3 = tocItemToUrl(course, {
      id,
      type,
      title,
      slug
    }, searchParams?.toString());
    $[0] = course;
    $[1] = id;
    $[2] = searchParams;
    $[3] = slug;
    $[4] = title;
    $[5] = type;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const targetUrl = t3;
  let t4;
  if ($[7] !== shouldPrefetch || $[8] !== targetUrl) {
    t4 = {
      component: Link,
      prefetch: shouldPrefetch,
      href: targetUrl
    };
    $[7] = shouldPrefetch;
    $[8] = targetUrl;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const linkProps = t4;
  let t5;
  if ($[10] !== router || $[11] !== shouldPrefetch || $[12] !== targetUrl) {
    t5 = () => {
      if (shouldPrefetch) {
        router.prefetch(targetUrl);
      }
    };
    $[10] = router;
    $[11] = shouldPrefetch;
    $[12] = targetUrl;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const prefetchLink = t5;
  let t6;
  if ($[14] !== learningStatusIcon) {
    t6 = <IconContainer>{learningStatusIcon}</IconContainer>;
    $[14] = learningStatusIcon;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== isCurrentlyDisplayed || $[17] !== label || $[18] !== linkProps || $[19] !== onClick || $[20] !== prefetchLink) {
    t7 = <TocItemHeading><TocItemLink isCurrentlyDisplayed={isCurrentlyDisplayed} variant="subheading" onClick={onClick} onMouseEnter={prefetchLink} onFocus={prefetchLink} {...linkProps}>{label}</TocItemLink></TocItemHeading>;
    $[16] = isCurrentlyDisplayed;
    $[17] = label;
    $[18] = linkProps;
    $[19] = onClick;
    $[20] = prefetchLink;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== isCurrentlyDisplayed || $[23] !== t6 || $[24] !== t7) {
    t8 = <TocItemContainer isCurrentlyDisplayed={isCurrentlyDisplayed}>{t6}{t7}</TocItemContainer>;
    $[22] = isCurrentlyDisplayed;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};
export default TocItemWrapper;
function _temp() {}